module.exports = __webpack_public_path__ + "static/media/macbook-pro.765cf7ff.glb";